/**
 * dooh-constant.js
 *
 * This file includes constant values required for Performance Brand solution.
 * This may include enums, reference IDs or data. For example:
 *
 * - data like the list of emails to show in various dropdowns
 * - account IDs for enabling specific functionality
 */

export const GEO_SUB_TAB_OPTIONS = [
  { id: 'country', value: 'Country' },
  { id: 'state', value: 'State', selected: true },
  { id: 'dma', value: 'DMA' },
];
export const DISTRIBUTION_DIMENSION_OPTIONS = [
  { id: 'campaign', value: 'Campaign' },
  { id: 'adgroup', value: 'Ad Group' },
  { id: 'mediatype', value: 'Media Type' },
  { id: 'creative', value: 'Creatives' },
  { id: 'audience', value: 'Audiences' },
  ...GEO_SUB_TAB_OPTIONS,
  { id: 'venueType', value: 'Venue Type' },
];

export const ACCOUNT_SPECIFIC_DISTRIBUTION_DIMENSION_OPTIONS = {
  73: [
    { id: 'campaign', value: 'Contract ID' },
    { id: 'adgroup', value: 'ConLine ID' },
    { id: 'audience', value: 'Tier' },
  ],
};

export const DISTRIBUTION_MEASUREMENT_OPTIONS = [
  { id: 'impressions', value: 'IMPs', selected: true },
  { id: 'spend', value: 'Spend', selected: false },
  // { id: 'clicks', value: 'Clicks', selected: false },
];
export const DISTRIBUTION_MEASUREMENT_OPTIONS_VENUE_TYPE = [
  { id: 'impressions', value: 'IMPs', selected: true },
];

export const DAILY_VIEW_METRIC_OPTIONS = [
  { id: 'impressions', value: 'Impressions', legendColor: '#00abb7', checked: true },
  { id: 'spend', value: 'Spend', legendColor: '#e23d56', checked: false },
  // { id: 'clicks', value: 'Clicks', legendColor: '#ff8f3a', checked: false },
];

export const ACTIVE_CAMPAIGN_SUB_TAB_OPTIONS = [
  { id: 'campaign', value: 'Active Campaigns' },
  { id: 'adgroup', value: 'Active Ad Groups', selected: true },
];

export const ACCOUNT_SPECIFIC_ACTIVE_CAMPAIGN_SUB_TAB_OPTIONS = {
  73: [
    { id: 'campaign', value: 'Active Contract ID' },
    { id: 'adgroup', value: 'Active ConLine ID', selected: true },
  ],
};

export const TOP_PERFORMANCE_DIMENTIONS = [
  { id: 'venueType', value: 'Venue Type', icon: 'house-building', checked: true },
  { id: 'creative', value: 'Creative', icon: 'rectangle-ad', checked: true },
  { id: 'audience', value: 'Audience', icon: 'users', checked: true },
];

export const ACCOUNT_SPECIFIC_TOP_PERFORMANCE_DIMENTIONS = {
  73: [{ id: 'audience', value: 'Tier', icon: 'users', checked: true }],
};

export const CAMPAIGN_SUB_TAB_OPTIONS = [
  { id: 'campaign', value: 'Campaigns' },
  { id: 'adgroup', value: 'Ad Groups', selected: true },
];

export const ACCOUNT_SPECIFIC_CAMPAIGN_SUB_TAB_OPTIONS = {
  73: [
    { id: 'campaign', value: 'Contract ID' },
    { id: 'adgroup', value: 'ConLine ID', selected: true },
  ],
};

export const DELIVERY_TAB_OPTIONS = [
  {
    id: 'campaign_adgroup',
    value: 'Campaigns & Ad Groups',
    subTabs: ACTIVE_CAMPAIGN_SUB_TAB_OPTIONS,
    selected: true,
  },
  { id: 'mediatype', value: 'Media Types' },
  { id: 'creative', value: 'Creatives' },
  { id: 'audience', value: 'Audiences' },
  { id: 'geo', value: 'Geo', subTabs: GEO_SUB_TAB_OPTIONS },
  // { id: 'device', value: 'Devices' },
  { id: 'venueType', value: 'Venue Type' },
  { id: 'conversions', value: 'Conversions', url: '/views/DOOHAttributionReport/OverallData' },
];

export const ACCOUNT_SPECIFIC_DELIVERY_TAB_OPTIONS = {
  73: [
    {
      id: 'campaign_adgroup',
      value: 'Campaigns & Ad Groups',
      subTabs: ACCOUNT_SPECIFIC_ACTIVE_CAMPAIGN_SUB_TAB_OPTIONS[73],
      selected: true,
    },
    { id: 'audience', value: 'Tier' },
  ],
};
export const DELIVERY_METRIC_OPTIONS = [
  { id: 'impressions', value: 'IMPs' },
  // { id: 'ctr', value: 'CTR' },
  // { id: 'vcr', value: 'VCR' },
  // { id: 'cpc', value: 'CPC' },
  // { id: 'cpcv', value: 'CPCV' },
  // { id: 'roas', value: 'ROAS' },
];
export const DELIVERY_METRIC_OPTIONS_VENUE_TYPE = [
  { id: 'impressions', value: 'IMPs', selected: true },
];

export const PERFORMANCE_ANALYSIS_DIMENSION_COLUMN = {
  key: 'name',
  value: 'Campaign Name',
  align: 'left',
};

export const PERFORMANCE_ANALYSIS_CAMPAIGN_COLUMNS = [
  {
    key: 'startDate',
    value: 'Start',
    align: 'left',
    formatter: { type: 'datetime', format: 'M/D/YYYY' },
  },
  {
    key: 'endDate',
    value: 'End',
    align: 'left',
    formatter: { type: 'datetime', format: 'M/D/YYYY' },
  },
  {
    key: 'budget',
    value: 'Budget',
    align: 'right',
    formatter: { type: 'number', format: '$0,0.[00]' },
  },
  {
    key: 'status',
    value: 'Status',
    align: 'left',
    formatter: { type: 'status' },
  },
  {
    key: 'actualPacing',
    value: 'Pacing',
    align: 'center',
    formatter: { type: 'pacing', format: '0%' },
  },
];

export const PERFORMANCE_ANALYSIS_COLUMNS = [
  {
    key: 'spend',
    value: 'Spend',
    align: 'right',
    formatter: { type: 'number', format: '$0,0.[00]' },
  },
  {
    key: 'impressions',
    value: 'IMPs',
    align: 'right',
    formatter: { type: 'number', format: '0,0' },
  },
  // {
  //   key: 'clicks',
  //   value: 'Clicks',
  //   align: 'right',
  //   formatter: { type: 'number', format: '0,0' },
  // },
];

export const PERFORMANCE_ANALYSIS_COLUMNS_VENUE_TYPE = [
  {
    key: 'impressions',
    value: 'IMPs',
    align: 'right',
    formatter: { type: 'number', format: '0,0' },
  },
];
export const PERFORMANCE_ANALYSIS_CONVERSIONS_COLUMNS = [];

export const PERFORMANCE_ANALYSIS_COLUMNS_PER_DIMENSION = {
  campaign: [...PERFORMANCE_ANALYSIS_CAMPAIGN_COLUMNS, ...PERFORMANCE_ANALYSIS_COLUMNS],
  adgroup: [...PERFORMANCE_ANALYSIS_CAMPAIGN_COLUMNS, ...PERFORMANCE_ANALYSIS_COLUMNS],
  venueType: [...PERFORMANCE_ANALYSIS_COLUMNS_VENUE_TYPE],
  other: [...PERFORMANCE_ANALYSIS_COLUMNS],
};

export const PERFORMANCE_ANALYSIS_DIMENSION_TITLES = {
  campaign: 'Campaign Name',
  adgroup: 'Ad Group Name',
  mediatype: 'Media Type',
  creative: 'Creative',
  audience: 'Audience',
  venueType: 'Venue Type',
};

export const ACCOUNT_SPECIFIC_PERFORMANCE_ANALYSIS_DIMENSION_TITLES = {
  73: {
    campaign: 'Contract ID Name',
    adgroup: 'ConLine ID Name',
    audience: 'Tier',
  },
};

export const REPORT_DIMENSION_OPTIONS = [
  { id: 'overall', value: 'Overall' },
  { id: 'day', value: 'Day' },
  ...DISTRIBUTION_DIMENSION_OPTIONS,
];
export const ACCOUNT_SPECIFIC_REPORT_DIMENSION_OPTIONS = {
  73: [...ACCOUNT_SPECIFIC_DISTRIBUTION_DIMENSION_OPTIONS[73]],
};

export const REPORT_DIMENSION_COLUMN = {
  ...PERFORMANCE_ANALYSIS_DIMENSION_COLUMN,
};
export const REPORT_METRIC_OPTIONS = [
  ...PERFORMANCE_ANALYSIS_COLUMNS,
  {
    key: 'cpm',
    infinityKey: 'cpmInfinity',
    value: 'CPM',
    align: 'right',
    formatter: { type: 'number', format: '$0.[00]' },
  },
  // {
  //   key: 'cpc',
  //   infinityKey: 'cpcInfinity',
  //   value: 'CPC',
  //   align: 'right',
  //   formatter: { type: 'number', format: '$0.[00]' },
  // },
];

export const REPORT_DIMENSION_TITLES = {
  overall: 'Overall',
  day: 'Day',
  campaign: 'Campaign Name',
  adgroup: 'Ad Group Name',
  mediatype: 'Media Type',
  creative: 'Creative',
  audience: 'Audience',
  venueType: 'Venue Type',
  geo: 'Geo',
  country: 'Country',
  state: 'State',
  dma: 'DMA',
};

export const ACCOUNT_SPECIFIC_REPORT_DIMENSION_TITLES = {
  73: {
    campaign: 'Contract ID Name',
    adgroup: 'ConLine ID Name',
    audience: 'Tier',
  },
};

export const DEFAULT_CONVERSION_WINDOW = 31;
export const CONVERSIONS_TAB_ID = 'conversions';
